export default __webpack_public_path__ + "static/media/icon_savings.a829affa.svg";